import { render, staticRenderFns } from "./IconFormModal.vue?vue&type=template&id=5f28ad78&scoped=true&"
import script from "./IconFormModal.vue?vue&type=script&lang=js&"
export * from "./IconFormModal.vue?vue&type=script&lang=js&"
import style0 from "./IconFormModal.vue?vue&type=style&index=0&id=5f28ad78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f28ad78",
  null
  
)

export default component.exports